var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2194_94",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2194_94",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABWklEQVR4nO3bPWoDMRCG4WlziWBys+ly6ASzB3GcxoIU+QHbMZ9WzwvbqpiHKVagKkmSJEmSJEmSJEmSJEmSVE9mkDPD56p6q6rXex24YF1Vx6p6uQfGe1Wdq+oDytUYp8sMt1tQvmKMD8r1GOdbUL7DgHI7xtUov4HYlNsw/mVLoDwYYwQlCGMEJQhjBCUIYwQlCGMEJQhjBCUIY7Q6SidhrI7SiRironQyxmooPQPGKig9E8beUXpGjL2i9MwYe0PpPWDsBaX3hDE7Su8RY1aU3jPGbCi9AsYsKL0SRjpKr4iRitIrY6ShNIwclIaRg9IwclAaRg5Kw8hBaRg5KA0jB6Vh5KA0jByUhpGD0jByUBpGDkrDeFyHyzvvn1BOf9zaHi9n6IGbcl75Cn0WlA1GDsoGIwdlg5GDssHIQdlg5KBsMHI6+M+QJEmSJEmSJEmSJEmSJKny+wQrgMS1KLj4wAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.6c803e14456db513a85ced8be95feff0.svg";
export { ForwardRef as ReactComponent };